/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_OrganisationInputs */

const en__field_organisation = /** @type {(inputs: _Field_OrganisationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`organisation`)
};

const de__field_organisation = /** @type {(inputs: _Field_OrganisationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "organisation" |
*
* @param {_Field_OrganisationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_organisation = /** @type {((inputs?: _Field_OrganisationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_OrganisationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_organisation(inputs)
	return de__field_organisation(inputs)
});